import Vue from 'vue'

Vue.use({
  install(vue) {
    vue.prototype.MASK_CPF = '###.###.###-##'
    vue.prototype.MASK_CNPJ = '##.###.###/####-##'
    vue.prototype.MASK_PHONE_BR = '(##) ####-####'
    vue.prototype.MASK_PHONE_BR_ADG = '(##) #####-####'
  }
})
